module.exports = __webpack_public_path__ + "img/pre-banner-top.99f8ca52.svg";